import React, { useState } from 'react';
import AccountPanel from './AccountPanel.jsx';
import packageJson from '../../package.json';

function TopBar({
    onToggleCourseHistory,
    isAuthenticated,
    currentUser,
    onSignOut,
    onNavigateToSignIn,
    onNavigateToSignUp,
    onNavigateToLearn,
    theme,
    onToggleTheme,
    onRefreshProfile
}) {
    const [accountPanelState, setAccountPanelState] = useState('hidden'); // 'hidden', 'entering', 'visible', 'exiting'

    const toggleAccountPanel = () => {
        if (accountPanelState === 'hidden') {
            setAccountPanelState('entering');
            setTimeout(() => setAccountPanelState('visible'), 10);
        } else if (accountPanelState === 'visible') {
            setAccountPanelState('exiting');
            setTimeout(() => setAccountPanelState('hidden'), 300);
        }
    };

    const closeAccountPanel = () => {
        if (accountPanelState === 'visible') {
            setAccountPanelState('exiting');
            setTimeout(() => setAccountPanelState('hidden'), 300);
        }
    };

    const handleSignInClick = () => {
        onNavigateToSignIn();
    };

    const handleSignUpClick = () => {
        onNavigateToSignUp();
    };

    const handleSignOut = () => {
        closeAccountPanel();
        onSignOut();
    };

    const handleLearnClick = () => {
        if (onNavigateToLearn) {
            onNavigateToLearn();
        }
    };

    return (
        <div className="topbar">
            <div className="topbar-left">
                <button className="hamburger-btn" onClick={onToggleCourseHistory}>
                    <div className="hamburger-line"></div>
                    <div className="hamburger-line"></div>
                    <div className="hamburger-line"></div>
                </button>
                <div className="logo-text">TeachingOrb <span className="version-badge">v{packageJson.version}</span></div>
            </div>
            
            <div className="topbar-right">
                {isAuthenticated ? (
                    <>
                        <div className="account-avatar" onClick={toggleAccountPanel}>
                            {currentUser?.name ? currentUser.name.charAt(0).toUpperCase() : (currentUser?.email ? currentUser.email.charAt(0).toUpperCase() : 'U')}
                        </div>
                        
                        <AccountPanel
                            accountPanelState={accountPanelState}
                            onToggleAccountPanel={toggleAccountPanel}
                            currentUser={currentUser}
                            onSignOut={handleSignOut}
                            theme={theme}
                            onToggleTheme={onToggleTheme}
                            onRefreshProfile={onRefreshProfile}
                        />
                    </>
                ) : (
                    <div className="auth-links">
                        <span className="auth-link" onClick={handleSignInClick}>Sign In</span>
                        <span className="auth-separator"> / </span>
                        <span className="auth-link" onClick={handleSignUpClick}>Sign Up</span>
                    </div>
                )}
            </div>
        </div>
    );
}

export default TopBar; 